<template>
    <div v-for="item in files" :key="item.rev" class="file-item" :class="{active: file_selection.index[item.rev]}" tabindex="0">
        <div class="checkbox">
            <input :id="item.rev" type="checkbox" tabindex="-1" :checked="file_selection.index[item.rev]">
            <label :for="item.rev" @click.prevent="onFileClick(item)"></label>
        </div>
        <div class="file"
            @click="onFileClick(item)"
        >
            <span v-if="item.is_dir === true"
            class="file-icon"
            >
                <i class="far fa-folder"></i>
            </span>

            <span  v-else-if="item.thumb_exists === true" class="file-thumb">
                <img :src="`${thumbnail_endpoint}&path=${item.path}&id=${item.rev}`">
            </span>

            <span  v-else class="file-icon">
                <i class="far fa-file"></i>
            </span>

            <span class="title">{{ item.name }}</span>
            <small v-if="item.bytes">{{ item.size }}</small>
        </div>
    </div>
</template>

<script setup>
  import SAPOMailConfigSingleton from '@/SAPOMailConfig';

  const thumbnail_endpoint = SAPOMailConfigSingleton.client.endpoints.imp_services + '/cloud?op=getThumbnail';

  const props = defineProps({
    file_selection: {
      required: true,
    },
    files: {
      required: true,
    }
  });

  const emit = defineEmits([
    'fileClick', 'folderClick'
  ]);

  const onFileClick = (item) => {
    if (item.is_dir) {
      emit('folderClick', item);
      return;
    }

    emit('fileClick', item);
  }
</script>